<template>
  <div class="card">
    <div class="card card-custom" >
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('settings.template.list') }}</h3>
        </div>
        <div class="card-toolbar">
        </div>
      </div>

      <div class="card-body" >
        <div class="row">
          <div class="col-md-6 col-lg-6 col-xl-6 mb-9" v-for="template in templates" :key="template?.id">
            <h2 class="text-center mt-7">{{template.type[locale]}}</h2>
            <div class="card shadow-sm " variant="gray">
              <div class="card-header align-items-center">
                <div class="fs-4 fw-bold" style="width: 80%">
                  <div class="d-flex flex-start align-items-center flex-equal fw-row w-100 me-4 py-5" :title="$t('settings.template.subjectUpdating')">
                    <span class="fw-bold">{{$t('settings.template.subject')}}</span>
                    <input :name="'subject-' + template.id" type="text" class="form-control form-control-flush fw-bold w-100 border-bottom border-gray-400 mb-2" v-model="template.subject" @keyup.enter="handleEnter(template)" :placeholder="$t('settings.template.subjectUpdating')">
                  </div>
                  <span class="badge badge-light-primary bg-hover-primary text-hover-white p-3 fs-6 mb-2 cursor-pointer" @click="openFileModal(template)">
                    {{ $t('settings.template.attach') }} {{template.files.length}}
                  </span>
                </div>
                <div class="card-toolbar">
                  <Button btn-class="btn-sm btn-icon me-2" type="button" icon-class="fa fa-edit text-primary" @click.prevent="editTemplate(template.template_id)"/>
                </div>
              </div>
              <div class="card-body d-flex flex-column p-8">
                <iframe :srcdoc="template.content" frameborder="0" style="border: none; width: 100%; height: 700px; overflow: auto; word-wrap: break-word; overflow-wrap: break-word;"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AttachFileModal id="open_attach_modal" :templateObject="templateData" @load="fetchDatas"/>
</template>

<script setup>
import { onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue";
import AttachFileModal from "./modals/AttachFileModal.vue";

const router = useRouter()
const store = useStore()
const {locale} = useLocales()

const templates = ref([])
const templateData = ref(null)

onMounted(() => {
  fetchDatas()
})

function fetchDatas() {
   store.dispatch('events/loadEventTemplateMail').then(res => {
    templates.value = res.data.map(t => ({
      ...t,
      subject: t.builder_template?.subject ?? '',
      files: t.builder_template?.attachments ?? []
    }));
   })
}

function editTemplate(id) {
  const url = router.resolve({ name: "template-builder", params: { id } }).href;
  window.open(url, '_blank');
}

function openFileModal(template) {
  templateData.value = template
  if(templateData.value){
    $('#open_attach_modal').modal('toggle')
  }
}

function handleEnter(template) {
  store.dispatch('events/saveTemplateSubject', {id: template.template_id, subject: template.subject})
    .then(res => {
      window.toastr['success'](i18n.global.t("notifications.update_template_uploaded"))
    })
}
</script>

